import { render, staticRenderFns } from "./TechSupport.vue?vue&type=template&id=506f1c97&"
import script from "./TechSupport.vue?vue&type=script&lang=js&"
export * from "./TechSupport.vue?vue&type=script&lang=js&"
import style0 from "./TechSupport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports